import '../../design/css/v2/vendor/leaflet.css';
import {DestinationMap} from '@/libs/DestinationMap';

function initMap(canvas) {
	const frame = canvas.closest('.destination-map__frame');
	const popup = frame.querySelector('[data-map-popup]');
	const popupImage = popup.querySelector('[data-map-popup-image]');
	const popupTitle = popup.querySelector('[data-map-popup-title]');
	const popupDescription = popup.querySelector('[data-map-popup-description]');
	const popupLink = popup.querySelector('[data-map-popup-link]');

	const bounds = JSON.parse(canvas.dataset.bounds || 'null');
	const properties = JSON.parse(canvas.dataset.properties || '[]');

	const map = new DestinationMap(canvas, {
		googleApiKey: canvas.dataset.googleMapsKey || ''
	}).init();

	if (bounds) {
		map.setBounds(bounds);
	}

	let activeMarker = null;

	const closePopup = (returnFocus = false) => {
		if (popup.hidden) {
			return;
		}
		popup.hidden = true;
		if (returnFocus) {
			activeMarker?.getElement()?.focus();
		}
	};

	const openPopup = (marker, property, fromKeyboard) => {
		activeMarker = marker;

		popupImage.replaceChildren();
		if (property.image) {
			const image = document.createElement('img');
			image.src = property.image;
			image.alt = '';
			popupImage.append(image);
		}
		popupImage.hidden = !property.image;

		popupTitle.textContent = property.name;

		popupDescription.innerHTML = property.description || '';
		popupDescription.hidden = !property.description;

		popupLink.hidden = !property.url;
		popupLink.href = property.url || '#';
		popupLink.setAttribute('aria-label', `View hotel, ${property.name}`);

		popup.hidden = false;
		if (fromKeyboard && property.url) {
			popupLink.focus();
		}
	};

	properties.forEach((property) => {
		const marker = map.addMarker(property.lat, property.lng, {
			alt: property.name,
			title: property.name
		});

		marker.on('click', () => openPopup(marker, property, false));
		marker.on('keydown', (event) => {
			const key = event.originalEvent.key;
			if (key === 'Enter' || key === ' ') {
				event.originalEvent.preventDefault();
				openPopup(marker, property, true);
			}
		});
	});

	document.addEventListener('click', (event) => {
		if (!popup.contains(event.target) && !event.target.closest('.leaflet-marker-icon')) {
			closePopup();
		}
	});

	frame.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closePopup(popup.contains(document.activeElement));
		}
	});

	new ResizeObserver(() => map.handleResize()).observe(canvas);
}

document.querySelectorAll('[data-destination-map]').forEach(initMap);
